import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-166f403a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "quantity"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "check-button"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "justify-content-between quantity quantity--alternative" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "check-button"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "quantity quantity--mode-2"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 2,
  class: "check-button"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.mode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.unitType != 'kg')
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                class: "minus quantity__minus",
                disabled: _ctx.modelNumber === _ctx.minimumBuyableAmount || _ctx.modelNumber === 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubtractOne()))
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "number",
            name: "quantity",
            class: "qty quantity__input",
            size: "4",
            value: _ctx.modelNumber,
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange($event)))
          }, null, 40, _hoisted_3),
          (_ctx.unitType != 'kg')
            ? (_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "button",
                class: "plus quantity__plus",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddOne())),
                disabled: _ctx.modelNumber === _ctx.maximumBuyableAmount
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.unitType == 'kg')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              (_ctx.unitType != 'kg')
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "button",
                    class: "minus quantity__minus",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubtractOne())),
                    disabled: _ctx.modelNumber === _ctx.minimumBuyableAmount || _ctx.modelNumber === 1
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("input", {
                type: "number",
                name: "quantity",
                class: "qty quantity__input quantity__input--full-width",
                size: "4",
                value: _ctx.modelNumber,
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChange($event)))
              }, null, 40, _hoisted_11)
            ]),
            _createElementVNode("div", null, [
              (_ctx.unitType != 'kg')
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "button",
                    class: "plus quantity__plus",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddOne())),
                    disabled: _ctx.modelNumber === _ctx.maximumBuyableAmount
                  }, null, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            (_ctx.unitType == 'kg')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode==2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_ctx.unitType != 'kg')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "button",
                      class: "minus quantity__minus",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubtractOne())),
                      disabled: _ctx.modelNumber === _ctx.minimumBuyableAmount || _ctx.modelNumber === 1
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              type: "number",
              name: "quantity",
              class: "qty quantity__input",
              size: "4",
              value: _ctx.modelNumber,
              onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChange($event)))
            }, null, 40, _hoisted_19)
          ]),
          (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_ctx.unitType != 'kg')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "button",
                      class: "plus quantity__plus",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onAddOne())),
                      disabled: _ctx.modelNumber === _ctx.maximumBuyableAmount
                    }, null, 8, _hoisted_21))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.unitType == 'kg')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}